import React, { Component } from "react";
import "./AuthUserList.css";
import Config from "../../config";
import Axios from "axios";
import { DatePicker, Row, Spin, Col, Input } from "antd";
import { Form } from '@ant-design/compatible';
import $, { post } from "jquery";
import PreviousIcon from "./PreviousIcon.png";
import NextIcon from "./NextIcon.png";
import paginationDecrement from "./paginationDecrement.png";
import paginationIncrement from "./paginationIncrement.png";
import DownloadIcon from "./DownloadIcon.png";
import CrossIcon from "./CrossIcon.png";
import SearchIcon from "./SearchIcon.png";
import AuthUserListsonder from "./Authlistforsonder"
// import '../memberSearch/Incidents/Incidents.css'
import ExportJsonExcel from "js-export-excel";
// import ErrorBoundaries from '../../ErrorBoundaries';
import { authListObject } from "../../store/broadcaster/BroadcastRegister";
import Postdata from "../Pages/Postdata";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
// import AddEventBlock from "../memberSearch/Incidents/AddEventBlock";

export class AuthUserList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columnHeaders: [
        "Req",
        "Abv",
        "Reference",
        "Sub ID",
        "Member Name",
        "From Date",
        "To Date",
        "D.O.S",
        "Status",
        "POS",
        "Auth",
        "Servicing",
        "Facility"
      ],
      filterReq: "",
      filterAbv: "",
      filterReference: "",
      filterSubId: "",
      filterMemberName: "",
      filterFromData:"",
      filterToData:"",
      filterDOS: "",
      filterStatus: "",
      filterPos: "",
      filterAuth: "",
      filterServicing:"",
      filterFacility:""
     ,
      authListData: [],
      authMessage : "",
      filterData: [],
      authListLoading: false,
      lodingdataspin:false,
      getNpi: sessionStorage.getItem("npivalue"),
      getPlanName: sessionStorage.getItem("planName"),
      gettaxId: sessionStorage.getItem("taxid"),
      SearchLoading: false,
      searchColumn: "",
      pageNumber: 1,
      totalPages: "",
      // pageSize: 15,
      totalRecords: "",
      totalRecordFound: "",

      currentPage: 1,
      todosPerPage: 10,
      upperPageBound: 5,
      lowerPageBound: 0,
      isPrevBtnActive: "disabled",
      isNextBtnActive: "",
      pageBound: 1,
      id: "",
      filterPageNumber: 1,
      // serialNumber : ""
      pageStatus: false,
      memberDetailsSubscriberId: "",
      authPage:
        this.props.activetab === undefined ||
          this.props.activetab === null ||
          this.props.activetab === ""
          ? "1"
          : this.props.activetab,
      tabName: "authList",
    };
  }

  getAuthorizationsList = (
    value,
    value1,
    value2,
    value3,
    value4,
    value5,
    value6
  ) => {
    this.setState({
      currentPage:
        this.state.pageStatus === value ? this.state.currentPage : value1,
      upperPageBound: value2,
      lowerPageBound: value3,
      pageBound: value4,
      SearchLoading: true,
      lodingdataspin:true,
      // isPrevBtnActive : value5,
      // isNextBtnActive : value6
    });

    // console.log("subscriber id ", this.state.memberDetailsSubscriberId);

    var postData1 = {
      SearchParameter: {
        // NPI: this.state.getNpi,
        // TaxID: this.state.gettaxId,
        // subscriberid: "aaa"
      },
      // PlanName: this.state.getPlanName,
      PlanName: this.state.getPlanName,
      PageNumber: this.state.pageStatus != value ? 1 : this.state.currentPage,
      // PageNumber :this.state.currentPage,
      PageSize: this.state.todosPerPage,
      RequestType: this.state.filterReq,
      Abbrevation: this.state.filterAbv,
      ReferenceNumber: this.state.filterReference,
      SubscriberID: this.state.filterSubId,
      MemberName: this.state.filterMemberName,
      ExpectedDOS: this.state.filterDOS,
      AuthStatus: this.state.filterStatus,
      PosAbb: this.state.filterPos,
      AuthorizationType: this.state.filterAuth,
      FromDate: this.state.filterFromData,
      ToDate: this.state.filterToData,
      ServicingProvider: this.state.filterServicing,
      FacilityName: this.state.filterFacility,
      IsDSNP: sessionStorage.getItem("IsDSNP") === "1" ? null : sessionStorage.getItem("IsDSNP") === "0" ? "0" : null
    };

    var postData2 = {
      SearchParameter: [
        {
          NPI: this.props.npi,
          TaxID: this.props.taxId,
        },
      ],

      PlanName: this.state.getPlanName,
      PageNumber: this.state.pageStatus != value ? 1 : this.state.currentPage,
      PageSize: this.state.todosPerPage,
      RequestType: this.state.filterReq,
      Abbrevation: this.state.filterAbv,
      ReferenceNumber: this.state.filterReference,
      SubscriberID: this.state.filterSubId,
      MemberName: this.state.filterMemberName,
      ExpectedDOS: this.state.filterDOS,
      AuthStatus: this.state.filterStatus,
      PosAbb: this.state.filterPos,
      AuthorizationType: this.state.filterAuth,
      FromDate: this.state.filterFromData,
      ToDate: this.state.filterToData,
      ServicingProvider: this.state.filterServicing,
      FacilityName: this.state.filterFacility,
      IsDSNP: sessionStorage.getItem("IsDSNP") === "1" ? null : sessionStorage.getItem("IsDSNP") === "0" ? "0" : null
    };

    var postData3 = {
      SearchParameter: {},

      PlanName: this.state.getPlanName,
      PageNumber: this.state.pageStatus != value ? 1 : this.state.currentPage,
      PageSize: this.state.todosPerPage,
      RequestType: this.state.filterReq,
      Abbrevation: this.state.filterAbv,
      ReferenceNumber: this.state.filterReference,
      SubscriberID: this.state.memberDetailsSubscriberId,
      MemberName: this.state.filterMemberName,
      ExpectedDOS: this.state.filterDOS,
      AuthStatus: this.state.filterStatus,
      PosAbb: this.state.filterPos,
      AuthorizationType: this.state.filterAuth,
      FromDate: this.state.filterFromData,
      ToDate: this.state.filterToData,
      ServicingProvider: this.state.filterServicing,
      FacilityName: this.state.filterFacility,
      IsDSNP: sessionStorage.getItem("IsDSNP") === "1" ? null : sessionStorage.getItem("IsDSNP") === "0" ? "0" : null
    };

    if (sessionStorage.getItem("ProviderRole") === "PROVIDER") {
      let npiList = JSON.parse(sessionStorage.getItem("npivalue")) || [];
      let taxIdList = JSON.parse(sessionStorage.getItem("taxid")) || [];
      let TaxNPIMappingForPayload = [];
      taxIdList.forEach((taxid) => {
        npiList.forEach((npi) => {
          TaxNPIMappingForPayload.push({
            TaxID: taxid || "",
            NPI: npi || "",
          });
        });
      });
      console.log(JSON.parse(sessionStorage.getItem("npivalue")))
      let npi = JSON.parse(sessionStorage.getItem("npivalue"));

      var postData4 = {
        // SearchParameter: JSON.parse(sessionStorage.getItem("taxid")).map(taxid => {
        //   return {
        //     NPI: npi || null,
        //     TaxID: taxid || null,
        //   }
        // }),
        SearchParameter:TaxNPIMappingForPayload,
        PlanName: this.state.getPlanName,
        PageNumber: this.state.pageStatus != value ? 1 : this.state.currentPage,
        PageSize: this.state.todosPerPage,
        RequestType: this.state.filterReq,
        Abbrevation: this.state.filterAbv,
        ReferenceNumber: this.state.filterReference,
        SubscriberID: this.state.filterSubId,
        MemberName: this.state.filterMemberName,
        ExpectedDOS: this.state.filterDOS,
        AuthStatus: this.state.filterStatus,
        PosAbb: this.state.filterPos,
        AuthorizationType: this.state.filterAuth,
        FromDate: this.state.filterFromData,
        ToDate: this.state.filterToData,
        ServicingProvider: this.state.filterServicing,
        FacilityName: this.state.filterFacility,
        IsDSNP: sessionStorage.getItem("IsDSNP") === "1" ? null : sessionStorage.getItem("IsDSNP") === "0" ? "0" : null
      };

      var postData6 = {
        SearchParameter: JSON.parse(sessionStorage.getItem("taxid")).map(taxid => {
          return {
            NPI: npi || null,
            TaxID: taxid || null,
          }
        }),

        PlanName: this.state.getPlanName,
        PageNumber: this.state.pageStatus != value ? 1 : this.state.currentPage,
        PageSize: this.state.todosPerPage,
        RequestType: this.state.filterReq,
        Abbrevation: this.state.filterAbv,
        ReferenceNumber: this.state.filterReference,
        SubscriberID: this.state.memberDetailsSubscriberId,
        MemberName: this.state.filterMemberName,
        ExpectedDOS: this.state.filterDOS,
        AuthStatus: this.state.filterStatus,
        PosAbb: this.state.filterPos,
        AuthorizationType: this.state.filterAuth,
        FromDate: this.state.filterFromData,
        ToDate: this.state.filterToData,
        ServicingProvider: this.state.filterServicing,
        FacilityName: this.state.filterFacility,
        IsDSNP: sessionStorage.getItem("IsDSNP") === "1" ? null : sessionStorage.getItem("IsDSNP") === "0" ? "0" : null
      };
    }

    if (sessionStorage.getItem("rolename").includes("Group User") || sessionStorage.getItem("rolename").includes("IPA User")) {
      let taxNpiMapping = JSON.parse(sessionStorage.getItem("rolename").includes("IPA User")
      ? sessionStorage.getItem("latestTaxidNpiMapping")
      : sessionStorage.getItem("taxidNpiMapping"));

      let TaxNPIMappingForPayload = [];

      taxNpiMapping.map((item) => {
        if (item.NPI) {
          item.NPI.map((items) => {
            TaxNPIMappingForPayload.push({
              TaxID: item.TaxID ? item.TaxID : "",
              NPI: items,
            });
          });
        }
      });

      var postData5 = {
        SearchParameter: TaxNPIMappingForPayload,
        PlanName: this.state.getPlanName,
        PageNumber: this.state.pageStatus != value ? 1 : this.state.currentPage,
        PageSize: this.state.todosPerPage,
        RequestType: this.state.filterReq,
        Abbrevation: this.state.filterAbv,
        ReferenceNumber: this.state.filterReference,
        SubscriberID: this.state.filterSubId,
        MemberName: this.state.filterMemberName,
        ExpectedDOS: this.state.filterDOS,
        AuthStatus: this.state.filterStatus,
        PosAbb: this.state.filterPos,
        AuthorizationType: this.state.filterAuth,
        FromDate: this.state.filterFromData,
        ToDate: this.state.filterToData,
        ServicingProvider: this.state.filterServicing,
        FacilityName: this.state.filterFacility,
        IsDSNP: sessionStorage.getItem("IsDSNP") === "1" ? null : sessionStorage.getItem("IsDSNP") === "0" ? "0" : null
      };

      var postData7 = {
        SearchParameter: TaxNPIMappingForPayload,
        PlanName: this.state.getPlanName,
        PageNumber: this.state.pageStatus != value ? 1 : this.state.currentPage,
        PageSize: this.state.todosPerPage,
        RequestType: this.state.filterReq,
        Abbrevation: this.state.filterAbv,
        ReferenceNumber: this.state.filterReference,
        SubscriberID: this.state.memberDetailsSubscriberId,
        MemberName: this.state.filterMemberName,
        ExpectedDOS: this.state.filterDOS,
        AuthStatus: this.state.filterStatus,
        PosAbb: this.state.filterPos,
        AuthorizationType: this.state.filterAuth,
        FromDate: this.state.filterFromData,
        ToDate: this.state.filterToData,
        ServicingProvider: this.state.filterServicing,
        FacilityName: this.state.filterFacility,
        IsDSNP: sessionStorage.getItem("IsDSNP") === "1" ? null : sessionStorage.getItem("IsDSNP") === "0" ? "0" : null
      };
    }
    // console.log(this.props.subId.item.SubscriberID)
    let postData =
      this.state.authPage === "1" &&
        sessionStorage.getItem("ProviderRole") === "PROVIDER"
        ? postData4
        : this.state.authPage === "1" &&
          (sessionStorage.getItem("rolename").includes("Group User") || sessionStorage.getItem("rolename").includes("IPA User"))
          ? postData5
          : sessionStorage.getItem("ProviderRole") === "PROVIDER"
            ? postData6
            : sessionStorage.getItem("rolename").includes("Group User") || sessionStorage.getItem("rolename").includes("IPA User")
              ? postData7
              : this.state.authPage === "1"
                ? postData1
                : this.state.authPage === "2"
                  ? postData2
                  : postData3;
    // console.log("post data", postData);

    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
    };
    
    Axios.post(Config.Auth + "/GetAllAuthorizations", postData, axiosConfig)
      .then((res) => {
        // Axios.get(Config.api + "/GetAllAuthorizations", axiosConfig).then((res) => {
        if (
          res.data.AuthorizationList.length != 0 ||
          res.data.AuthorizationList != null ||
          res.data.AuthorizationList != undefined ||
          res.data.AuthorizationList != ""
        ) {
          this.setState({
            authListData: res.data.AuthorizationList,
            totalPages: res.data.TotalPages,
            authMessage : res.data.Message,
            totalRecords: Math.ceil(
              res.data.TotalRecords / this.state.todosPerPage
            ),
            authListLoading: true,
            SearchLoading: false,
            lodingdataspin:false,
            // filterData : this.state.filterData,
            totalRecordFound: res.data.TotalRecords,
          });
        } else {
          this.setState({
            authListData: [],
            authMessage : res.data.Message,
            authListLoading: true,
            lodingdataspin:false,
          });
        }
        if (value === "downloadExcel") {
          let data = res.data.AuthorizationList;
          let option = {};
          let dataTable = [];
          if (data.length > 0) {
            if (data) {
              for (let i in data) {
                let obj = {
                  Req: data[i].Req,
                  Abv: data[i].Abv,
                  Reference: data[i].Reference,
                  SubId: data[i].SubId,
                  MemberName: data[i].MemberName,
                  FromDate:data[i].FromDate,
                  ToDate:data[i].ToDate,
                  DOS: data[i].DOS,
                  Status: data[i].Status,
                  POS: data[i].POS,
                  Auth: data[i].Auth,
                  Servicing:data[i].ServicingProvider,
                  Facility:data[i].FacilityName
                };
                dataTable.push(obj);
              }
            }
          }
          option.fileName = "Auth List";
          option.datas = [
            {
              sheetData: dataTable,
              sheetName: "Auth List",
              sheetHeader: [
                "Req",
                "Abv",
                "Reference",
                "Sub ID",
                "Member Name",
                "From Date",
                "To Date",
                "D.O.S",
                "Status",
                "POS",
                "Auth",
                "Servicing",
                "Facility"
              ],
            },
          ];
          let toExcel = new ExportJsonExcel(option);
          toExcel.saveExcel();
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          authListData: [],
          authListLoading: true,
        });
      });
  };

  componentDidMount() {
    if(sessionStorage.getItem("planName") !== 'sonder'){ 
      this.getAuthorizationsList(
        false,
        this.state.currentPage,
        this.state.upperPageBound,
        this.state.lowerPageBound,
        this.state.pageBound,
        this.state.isPrevBtnActive,
        this.state.isNextBtnActive
      );
    }
  }

  componentDidUpdate() {
    $("ul li.active").removeClass("active");
    $("ul li#" + this.state.currentPage).addClass("active");
    // this.AdmissionListUpdatedbyEvents()
  }
  filterOnchange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({
      [name]: value,
      // currentPage : 1
    });
  };

  columnAscendingOrder = (event, sortKey) => {
    const data = this.state.authListData;
    data.sort((a, b) => {
      const a1 = a[sortKey] === null || a[sortKey] === "" ? "" : a[sortKey];
      const b1 = b[sortKey] === null || a[sortKey] === "" ? "" : b[sortKey];
      return a1.localeCompare(b1);
    });
    this.setState({ data });
  };

  ColumnDescendingOrder = (event, sortKey) => {
    const data = this.state.authListData;
    data.sort((a, b) => {
      const a1 = a[sortKey] === null || a[sortKey] === "" ? "" : a[sortKey];
      const b1 = b[sortKey] === null || a[sortKey] === "" ? "" : b[sortKey];
      return b1.localeCompare(a1);
    });
    this.setState({ data });
  };

  dosOnChange = (date, dateString) => {
    // console.log(dateString)
    this.setState({
      filterDOS: dateString,
    });
  };

  fromdateOnChange = (date, dateString) => {
    // console.log(dateString)
    this.setState({
      filterFromData: dateString,
    });
  };

  todateOnChange = (date, dateString) => {
    // console.log(dateString)
    this.setState({
      filterToData: dateString,
    });
  };

  tableHeader = () => {
    const { getFieldDecorator } = this.props.form;
    return (
      <thead>
        <tr>
          <th>
            <div style={{ marginTop: "-30px" }}>
              <div>#</div>
            </div>
          </th>
          <th>
            <div>
              <div className="sortingArrows">
                <div> {this.state.columnHeaders[0]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "Req")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "Req")}
                  ></div>
                </div>
              </div>

              <div>
                <Input
                  className="inputStyle"
                  name="filterReq"
                  type="text"
                  value={this.state.filterReq}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  size="small"
                  onPressEnter={() =>
                    this.getAuthorizationsList(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
          <th>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[1]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "Abv")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "Abv")}
                  ></div>
                </div>
              </div>
              <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterAbv"
                  type="text"
                  value={this.state.filterAbv}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.getAuthorizationsList(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
          <th>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[2]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "Reference")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "Reference")}
                  ></div>
                </div>
              </div>
              <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterReference"
                  type="text"
                  value={this.state.filterReference}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.getAuthorizationsList(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
          <th>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[3]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "SubId")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "SubId")}
                  ></div>
                </div>
              </div>
              <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterSubId"
                  type="text"
                  value={this.state.filterSubId}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.getAuthorizationsList(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
          <th>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[4]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "MemberName")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "MemberName")}
                  ></div>
                </div>
              </div>
              <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterMemberName"
                  type="text"
                  value={this.state.filterMemberName}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.getAuthorizationsList(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
          <th>
                  <div>
                    <div className="sortingArrows">
                      <div style={{ marginTop: "-8px" }}>
                        {this.state.columnHeaders[5]}
                      </div>
                      <div style={{ marginTop: "-10px" }}>
                        <div
                          className="triangle triangle-4"
                          onClick={(e) => this.columnAscendingOrder(e, "FromDate")}
                        ></div>
                        <div
                          className="triangle triangle-5"
                          onClick={(e) => this.ColumnDescendingOrder(e, "FromDate")}
                        ></div>
                      </div>
                    </div>
                    <div>
                    {getFieldDecorator("filterFromData", {
                  initialValue:
                    this.state.filterFromData != "" || this.state.filterFromData != null
                      ? this.state.filterFromData
                      : "",
                })(
                  <DatePicker
                    size="small"
                    suffixIcon
                    className="inputStyle datePicker"
                    style={{ width: "100%", marginTop: "10px" }}
                    onChange={(date, dateString) =>
                      this.fromdateOnChange(date, dateString)
                    }
                    // disabledDate={d =>
                    //     !d || d.isAfter(today, "day")
                    // }
                    format={"MM/DD/YYYY"}
                    placeholder="Select"
                  />
                )}{" "}
                    </div>
                  </div>
          </th>
                <th>
                  <div>
                    <div className="sortingArrows">
                      <div style={{ marginTop: "-8px" }}>
                        {this.state.columnHeaders[6]}
                      </div>
                      <div style={{ marginTop: "-10px" }}>
                        <div
                          className="triangle triangle-4"
                          onClick={(e) => this.columnAscendingOrder(e, "ToDate")}
                        ></div>
                        <div
                          className="triangle triangle-5"
                          onClick={(e) => this.ColumnDescendingOrder(e, "ToDate")}
                        ></div>
                      </div>
                    </div>
                    <div>
                    {getFieldDecorator("filterToData", {
                  initialValue:
                    this.state.filterToData != "" || this.state.filterToData != null
                      ? this.state.filterToData
                      : "",
                })(
                  <DatePicker
                    size="small"
                    suffixIcon
                    className="inputStyle datePicker"
                    style={{ width: "100%", marginTop: "10px" }}
                    onChange={(date, dateString) =>
                      this.todateOnChange(date, dateString)
                    }
                    // disabledDate={d =>
                    //     !d || d.isAfter(today, "day")
                    // }
                    format={"MM/DD/YYYY"}
                    placeholder="Select"
                  />
                )}{" "}
                    </div>
                  </div>
                </th>
          <th>
            <div>
              <div className="sortingArrows">
                <div style={{ marginTop: "-8px" }}>
                  {this.state.columnHeaders[7]}
                </div>
                <div style={{ marginTop: "-10px" }}>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "DOS")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "DOS")}
                  ></div>
                </div>
              </div>
              <div>
                {getFieldDecorator("filterDOS", {
                  initialValue:
                    this.state.filterDOS != "" || this.state.filterDOS != null
                      ? this.state.filterDOS
                      : "",
                })(
                  <DatePicker
                    size="small"
                    suffixIcon
                    className="inputStyle datePicker"
                    style={{ width: "100%", marginTop: "10px" }}
                    onChange={(date, dateString) =>
                      this.dosOnChange(date, dateString)
                    }
                    // disabledDate={d =>
                    //     !d || d.isAfter(today, "day")
                    // }
                    format={"MM/DD/YYYY"}
                    placeholder="Select"
                  />
                )}{" "}
              </div>
            </div>
          </th>
          <th>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[8]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "Status")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "Status")}
                  ></div>
                </div>
              </div>
              <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterStatus"
                  type="text"
                  value={this.state.filterStatus}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.getAuthorizationsList(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
          <th>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[9]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "POS")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "POS")}
                  ></div>
                </div>
              </div>
              <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterPos"
                  type="text"
                  value={this.state.filterPos}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.getAuthorizationsList(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
          <th>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[10]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "Auth")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "Auth")}
                  ></div>
                </div>
              </div>
              <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterAuth"
                  type="text"
                  value={this.state.filterAuth}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.getAuthorizationsList(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
          <th>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[11]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "ServicingProvider")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "ServicingProvider")}
                  ></div>
                </div>
              </div>
              <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterServicing"
                  type="text"
                  value={this.state.filterServicing}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.getAuthorizationsList(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
         
          <th>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[12]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "FacilityName")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "FacilityName")}
                  ></div>
                </div>
              </div>
              <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterFacility"
                  type="text"
                  value={this.state.filterFacility}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.getAuthorizationsList(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
        </tr>
      </thead>
    );
  };

  getAuthDetails = (user) => {
    // console.log("user list details ", user);
    this.props.getDetails(user);
  };

  handleClick = (event) => {
    let listid = Number(event.target.id);
    // console.log(event.target.id)
    this.setState(
      {
        currentPage: listid,
        // filterPageNumber : listid
        // todosPerPage: 20,
        pageStatus: false,
      },
      () => {
        this.setPrevAndNextBtnClass(listid);
        this.getAuthorizationsList(
          false,
          this.state.currentPage,
          this.state.upperPageBound,
          this.state.lowerPageBound,
          this.state.pageBound,
          this.state.isPrevBtnActive,
          this.state.isNextBtnActive
        );
      }
    );
    $("ul li.active").removeClass("active");
    $("ul li#" + listid).addClass("active");
  };

  setPrevAndNextBtnClass = (listid) => {
    var totalPage;

    totalPage = this.state.totalRecords;

    this.setState({
      isNextBtnActive: "disabled",
      pageStatus: false,
    });
    this.setState({ isPrevBtnActive: "disabled" });
    if (totalPage === listid && totalPage > 1) {
      this.setState({ isPrevBtnActive: "" });
    } else if (listid === 1 && totalPage > 1) {
      this.setState({ isNextBtnActive: "" });
    } else if (totalPage > 1) {
      this.setState({ isNextBtnActive: "" });
      this.setState({ isPrevBtnActive: "" });
    }
  };

  btnIncrementClick = () => {
    this.setState({
      upperPageBound: this.state.upperPageBound + this.state.pageBound,
    });
    this.setState({
      lowerPageBound: this.state.lowerPageBound + this.state.pageBound,
    });
    let listid = this.state.upperPageBound + 1;
    this.setState({ currentPage: listid }, () => {
      this.setState({
        pageStatus: false,
      });
      this.setPrevAndNextBtnClass(listid);
      this.getAuthorizationsList(
        false,
        this.state.currentPage,
        this.state.upperPageBound,
        this.state.lowerPageBound,
        this.state.pageBound,
        this.state.isPrevBtnActive,
        this.state.isNextBtnActive
      );
    });
  };

  btnDecrementClick = () => {
    this.setState({
      upperPageBound: this.state.upperPageBound - this.state.pageBound,
    });
    this.setState({
      lowerPageBound: this.state.lowerPageBound - this.state.pageBound,
    });
    let listid = this.state.upperPageBound - 5;
    this.setState({ currentPage: listid }, () => {
      this.setState({
        pageStatus: false,
      });
      this.setPrevAndNextBtnClass(listid);
      this.getAuthorizationsList(
        false,
        this.state.currentPage,
        this.state.upperPageBound,
        this.state.lowerPageBound,
        this.state.pageBound,
        this.state.isPrevBtnActive,
        this.state.isNextBtnActive
      );
    });
  };

  btnPrevClick = () => {
    if ((this.state.currentPage - 1) % this.state.pageBound === 0) {
      this.setState({
        upperPageBound: this.state.upperPageBound - this.state.pageBound,
      });
      this.setState({
        lowerPageBound: this.state.lowerPageBound - this.state.pageBound,
      });
    }
    let listid = this.state.currentPage - 1;
    this.setState({ currentPage: listid }, () => {
      this.setState({
        pageStatus: false,
      });
      this.setPrevAndNextBtnClass(listid);
      this.getAuthorizationsList(
        false,
        this.state.currentPage,
        this.state.upperPageBound,
        this.state.lowerPageBound,
        this.state.pageBound,
        this.state.isPrevBtnActive,
        this.state.isNextBtnActive
      );
    });
  };

  btnNextClick = () => {
    if (this.state.currentPage + 1 > this.state.upperPageBound) {
      this.setState({
        upperPageBound: this.state.upperPageBound + this.state.pageBound,
      });
      this.setState({
        lowerPageBound: this.state.lowerPageBound + this.state.pageBound,
      });
    }
    let listid = this.state.currentPage + 1;
    this.setState({ currentPage: listid }, () => {
      this.setState({
        pageStatus: false,
      });
      this.setPrevAndNextBtnClass(listid);
      this.getAuthorizationsList(
        false,
        this.state.currentPage,
        this.state.upperPageBound,
        this.state.lowerPageBound,
        this.state.pageBound,
        this.state.isPrevBtnActive,
        this.state.isNextBtnActive
      );
    });
  };

  paginationIncrement = () => {
    // if(this.state.totalRecords != this.state.currentPage){
    //     alert("hi")
    // }
    this.setState(
      {
        todosPerPage: this.state.todosPerPage + 10,
        pageStatus: false,
      },

      () =>
        this.getAuthorizationsList(
          false,
          this.state.currentPage,
          this.state.upperPageBound,
          this.state.lowerPageBound,
          this.state.pageBound,
          this.state.isPrevBtnActive,
          this.state.isNextBtnActive
        )
    );
  };

  paginationDecrement = () => {
    if (this.state.todosPerPage > 10) {
      this.setState(
        {
          todosPerPage: this.state.todosPerPage - 10,
          pageStatus: false,
        },
        () =>
          this.getAuthorizationsList(
            false,
            this.state.currentPage,
            this.state.upperPageBound,
            this.state.lowerPageBound,
            this.state.pageBound,
            this.state.isPrevBtnActive,
            this.state.isNextBtnActive
          )
      );
    } else {
      this.setState(
        {
          todosPerPage: this.state.todosPerPage,
          pageStatus: false,
        },
        () =>
          this.getAuthorizationsList(
            false,
            this.state.currentPage,
            this.state.upperPageBound,
            this.state.lowerPageBound,
            this.state.pageBound,
            this.state.isPrevBtnActive,
            this.state.isNextBtnActive
          )
      );
    }
    // this.getAuthorizationsList(false, this.state.currentPage,this.state.upperPageBound,this.state.lowerPageBound,this.state.pageBound, this.state.isPrevBtnActive, this.state.isNextBtnActive)
  };

  resetFields = () => {
    this.setState(
      {
        filterReq: "",
        filterAbv: "",
        filterReference: "",
        filterSubId: "",
        filterMemberName: "",
        filterFromData:"",
        filterToData:"",
        filterDOS: "",
        filterStatus: "",
        filterPos: "",
        filterAuth: "",
        filterServicing:"",
        filterFacility:"",
        currentPage: 1,
        todosPerPage: 10,
        // filterPageNumber : 1,
        pageStatus: false,
        totalPages: "",
        // currentPage: 1,
        // todosPerPage: 10,
        upperPageBound: 5,
        lowerPageBound: 0,
        isPrevBtnActive: "disabled",
        isNextBtnActive: "",
        pageBound: 1,
      },
      () => {
        this.getAuthorizationsList(true, 1, 5, 0, 1);
        this.props.form.setFieldsValue({
          filterDOS: "",
        });
        this.props.form.setFieldsValue({
          filterToData: "",
        });
        this.props.form.setFieldsValue({
          filterFromData: "",
        });
      }
    );
  };

  render() {
    // console.log(typeof(this.props.taxId))
    // console.log("-props in auth page", this.props.subId);
    console.log("state",this.state.filterAbv)

    if (this.state.authPage != "1" && this.state.authPage != "2") {
      this.state.memberDetailsSubscriberId = this.props.subId.SubscriberID;
    } else {
      this.state.memberDetailsSubscriberId = "";
    }
    const {
      currentPage,
      todosPerPage,
      upperPageBound,
      lowerPageBound,
      isPrevBtnActive,
      isNextBtnActive,
    } = this.state;

    const { getFieldDecorator } = this.props.form;
    // var currentTodos;
    this.state.filterData = this.state.authListData.filter((e) => {
      var req =
        e.Req === null || e.Req === undefined ? "" : e.Req.replace(/\s+/g, " ");
      var abv =
        e.Abv === null || e.Abv === undefined ? "" : e.Abv.replace(/\s+/g, " ");
      var reference =
        e.Reference === null || e.Reference === undefined
          ? ""
          : e.Reference.replace(/\s+/g, " ");
      var subId =
        e.SubId === null || e.SubId === undefined
          ? ""
          : e.SubId.replace(/\s+/g, " ");
      var memberName =
        e.MemberName === null || e.MemberName === undefined
          ? ""
          : e.MemberName.replace(/\s+/g, " ");
      var dos = e.DOS === null || e.DOS === undefined ? "" : e.DOS.replace(/\s+/g, " ");
      var fromdate = e.FromDate === null || e.FromDate === undefined ? "" : e.FromDate.replace(/\s+/g, " ");
      var todate = e.ToDate === null || e.ToDate === undefined ? "" : e.ToDate.replace(/\s+/g, " ");
      var status =
        e.Status === null || e.Status === undefined
          ? ""
          : e.Status.replace(/\s+/g, " ");
      var pos =
        e.POS === null || e.POS === undefined ? "" : e.POS.replace(/\s+/g, " ");
      var auth =
        e.Auth === null || e.Auth === undefined
          ? ""
          : e.Auth.replace(/\s+/g, " ");
        var servicingProvider = e.ServicingProvider === null || e.ServicingProvider === undefined ? "" : e.ServicingProvider.replace(/\s+/g, " ");
      var facilityName = e.FacilityName === null || e.FacilityName === undefined  ? "" : e.FacilityName.replace(/\s+/g, " ");

      if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterReq.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterAbv.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterReference.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterSubId.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterMemberName.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterDOS.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterStatus.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterPos.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterAuth.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterMode.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterDx.toLocaleLowerCase());
      }
      return (
        req.toLowerCase().includes(this.state.filterReq.toLowerCase()) &&
        abv.toLowerCase().includes(this.state.filterAbv.toLowerCase()) &&
        reference
          .toLowerCase()
          .includes(this.state.filterReference.toLowerCase()) &&
        subId.toLowerCase().includes(this.state.filterSubId.toLowerCase()) &&
        memberName
          .toLowerCase()
          .includes(this.state.filterMemberName.toLowerCase()) &&
        dos.toLowerCase().includes(this.state.filterDOS.toLowerCase()) &&
        fromdate.toLowerCase().includes(this.state.filterFromData.toLowerCase()) &&
        todate.toLowerCase().includes(this.state.filterToData.toLowerCase()) &&
        status.toLowerCase().includes(this.state.filterStatus.toLowerCase()) &&
        pos.toLowerCase().includes(this.state.filterPos.toLowerCase()) &&
        auth.toLowerCase().includes(this.state.filterAuth.toLowerCase()) &&
        servicingProvider.toLowerCase().includes(this.state.filterServicing.toLowerCase()) &&
        facilityName.toLowerCase().includes(this.state.filterFacility.toLowerCase())
      );
    });

    const pageNumbers = [];

    for (let i = 1; i <= this.state.totalRecords; i++) {
      pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map((number, index) => {
      if (number === 1 && currentPage === 1) {
        return (
          <div>
            <li
              key={index}
              className="active"
              id={number}
              onClick={this.handleClick}
            >
              <a href="#" id={number}>
                {number}
              </a>
            </li>
          </div>
        );
      } else if (number < upperPageBound + 1 && number > lowerPageBound) {
        return (
          <li key={number} id={number} onClick={this.handleClick}>
            <a href="#" id={number}>
              {number}
            </a>
          </li>
        );
      }
    });

    let pageIncrementBtn = null;
    if (pageNumbers.length > upperPageBound) {
      pageIncrementBtn = (
        <li className="">
          <a href="#" onClick={this.btnIncrementClick}>
            {" "}
            &hellip;{" "}
          </a>
        </li>
      );
    }
    let pageDecrementBtn = null;
    if (lowerPageBound >= 1) {
      pageDecrementBtn = (
        <li className="">
          <a href="#" onClick={this.btnDecrementClick}>
            {" "}
            &hellip;{" "}
          </a>
        </li>
      );
    }
    let renderPrevBtn = null;
    if (isPrevBtnActive === "disabled") {
      renderPrevBtn = (
        <li className="isPrevBtnActive pageDisabled">
          <img src={PreviousIcon} alt="Left Arrow" />
        </li>
      );
    } else {
      renderPrevBtn = (
        <li className="isPrevBtnActive" onClick={this.btnPrevClick}>
          <img src={PreviousIcon} alt="Left Arrow" id="btnPrev" />
        </li>
      );
    }
    let renderNextBtn = null;
    if (isNextBtnActive === "disabled") {
      renderNextBtn = (
        <li className="isNextBtnActive pageDisabled">
          <img src={NextIcon} alt="Right Arrow" />
        </li>
      );
    } else if (this.state.currentPage === 1 && this.state.totalPages === 1) {
      renderNextBtn = (
        <li className="isNextBtnActive pageDisabled">
          <img src={NextIcon} alt="Right Arrow" />
        </li>
      );
    } else {
      renderNextBtn = (
        <li className="isNextBtnActive " onClick={this.btnNextClick}>
          <img src={NextIcon} alt="Right Arrow" id="btnNext" />
        </li>
      );
    }

    return (

       <div>
        {sessionStorage.getItem("planName") !== 'sonder' && (
        <div>
         
        {this.props.fromPage && (
          <div>
            {/* <ErrorBoundaries> */}
            {/* <AddEventBlock
              uniqueId={this.props.uniqueId}
              dataCount={this.state.filterData.length}
              tabName="Auth"
              userDetails={this.props.memberDetails}
              callerId={this.props.callerId}
              activeKey={this.props.activeKey}
            /> */}
            {/* </ErrorBoundaries> */}
          </div>
        )}
        <div className="mydiv">
          <table className="authTable authTable1">{this.tableHeader()}</table>
          {(this.state.filterReq != null && this.state.filterReq != "") ||
            (this.state.filterAbv != null) ||
            (this.state.filterReference != null &&
              this.state.filterReference != "") ||
            (this.state.filterSubId != null && this.state.filterSubId != "") ||
            (this.state.filterMemberName != null &&
              this.state.filterMemberName != "") ||
              (this.state.filterToData != null && this.state.filterToData != "") ||
              (this.state.filterFromData != null && this.state.filterFromData != "") ||
            (this.state.filterDOS != null && this.state.filterDOS != "") ||
            (this.state.filterStatus != null && this.state.filterStatus != "") ||
            (this.state.filterPos != null && this.state.filterPos != "") ||
            (this.state.filterAuth != null && this.state.filterAuth != "") ||
            (this.state.filterFacility != null && this.state.filterFacility != "") ||
            (this.state.filterServicing != null && this.state.filterServicing != "") ? (
            <div className="AuthpositionRight">
              <span className="authCrossButtonBg" onClick={this.resetFields}>
                <img
                  className="actionButtons"
                  src={CrossIcon}
                  style={{ width: "11px", height: "11px" }}
                />
              </span>
              <span
                className="authSearchButtonBg"
                onClick={() =>
                  this.getAuthorizationsList(true, 1, 5, 0, 1, "disabled", "")
                }
              >
                <img
                  className="actionButtons"
                  src={SearchIcon}
                  width="13"
                  height="13"
                />
              </span>
            </div>
          ) : (
            ""
          )}

          <table className="authTable authTable1">
            <tbody className="tableBody">
              {this.state.filterData.length > 0 && this.state.SearchLoading === false &&
                this.state.authListLoading === true &&
                this.state.filterData.map((user, index) => {
                  if (index <= 8) {
                    var serialNumber = "0" + (index + 1);
                  } else {
                    var serialNumber = index + 1;
                  }
                  // this.state.serialNumber = this.state.todosPerPage * (this.state.currentPage - 1) + index + 1
                  return (
                    <tr key={index} onClick={() => this.getAuthDetails(user)}>
                      {/* <td>{this.state.todosPerPage * (this.state.currentPage - 1) + index + 1}.</td> */}
                      <td>{serialNumber}</td>
                      <td
                        className={
                          user.Req === "EX" ? "userReqRed" : "userReqGreen"
                        }
                      >
                        {user.Req}
                      </td>
                      <td>{user.Abv}</td>
                    <td>{user.Reference}</td>
                    <td>{user.SubId}</td>
                    <td>{user.MemberName}</td>
                    <td>{user.FromDate}</td>
                    <td>{user.ToDate}</td>
                    <td>{user.DOS}</td>
                    <td>{user.Status}</td>
                    <td>{user.POS}</td>
                    <td>{user.Auth}</td>
                   <td>  <EllipsisWithTooltip>{user.ServicingProvider}</EllipsisWithTooltip></td>
                    <td><EllipsisWithTooltip>{user.FacilityName}</EllipsisWithTooltip></td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          {
            (this.state.SearchLoading === true && (sessionStorage.getItem("planName") === 'ultimate' ||  sessionStorage.getItem("planName") === 'csh') )  && 
            <div className="mt-5 mb-5 h3 d-flex justify-content-center ">
              <Spin size="large" tip="Loading..." />
            </div>
          }
          {this.state.filterData.length === 0 && this.state.SearchLoading === false &&
            this.state.authListLoading === false && (
              <div className="mt-5 mb-5 h3 d-flex justify-content-center ">
                <Spin size="large" tip="Loading..." />
              </div>
            )}

             {/* {this.state.lodingdataspin === true  && (
              <div className="mt-5 mb-5 h3 d-flex justify-content-center ">
                <Spin size="large" tip="Loading..." />
              </div>
            )} */}



          {this.state.filterData.length === 0 && this.state.SearchLoading === false &&
                this.state.authListLoading === true && (
                  <div className="mt-5 mb-5 h5 d-flex justify-content-center">
                    <span>
                     {this.state.authMessage
                      ? this.state.authMessage
                      : "No results found. Please check the search criteria and try again."}
                    </span>
                  </div>
                )}
        </div>
        {this.state.filterData.length > 0 && (
          <div className="page-bottom" style={{ marginTop: "8px" }}>
            {this.state.totalRecordFound > 10 ? (
              <ul
                className="pagination"
                style={{ margin: "0px", padding: "0px" }}
              >
                {renderPrevBtn}
                {pageDecrementBtn}
                {renderPageNumbers}
                {pageIncrementBtn}
                {renderNextBtn}
              </ul>
            ) : (
              <div></div>
            )}
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div>
                {this.state.totalRecordFound > 10 ? (
                  <div className="page-bottom-pagination-buttons">
                    <button
                      className="page-bottom-buttons"
                      onClick={this.paginationIncrement}
                    >
                      <img
                        src={paginationIncrement}
                        alt="IncrementIcon"
                        style={{
                          width: "9px",
                          height: "9px",
                          marginLeft: "-2px",
                          marginTop: "-2px",
                        }}
                      />
                    </button>
                    <span className="page-bottom-buttons-text ">
                      <b>{this.state.todosPerPage}</b>
                      <b>Rows</b>
                    </span>
                    <button
                      className="page-bottom-buttons"
                      onClick={this.paginationDecrement}
                    >
                      <img
                        src={paginationDecrement}
                        alt="DecrementIcon"
                        style={{
                          width: "9px",
                          marginLeft: "-2px",
                          marginTop: "-2px",
                        }}
                      />
                    </button>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
              <div style={{ marginLeft: "8px", marginRight: "12px" }}>
                <button
                  className="page-bottom-downolad-button"
                  type="submit"
                  onClick={() =>
                    this.getAuthorizationsList(
                      "downloadExcel",
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                >
                  <img
                    src={DownloadIcon}
                    alt="downloadIcon"
                    className="page-bottom-download-icon"
                  />
                  <span className="page-bottom-download-text">Download</span>
                </button>
              </div>
            </div>
          </div>
        )}
        
         
       </div>
        )}

        {sessionStorage.getItem("planName")  === 'sonder' && (
          <div>
          <AuthUserListsonder User={this.props.user}  fromPage={this.props.fromPage}></AuthUserListsonder>
          </div>
        )}
      </div>

      
  
    );
  }
}

// export default AuthUserList;
export default Form.create({ name: "AuthUserList" })(AuthUserList);
